import {api} from './api';
import {captureSession} from './sessionScope';
// The browser may still be reading the object URL right after click():
// revoke it a moment later, never synchronously.
export function saveBlob(blob, filename) {
  const objectUrl=URL.createObjectURL(blob);
  const link=document.createElement('a');link.href=objectUrl;link.download=filename;link.click();
  setTimeout(()=>URL.revokeObjectURL(objectUrl),1000);
}
export async function downloadAuthorized(url, filename, params) {
  const session = captureSession();
  const response = await api.get(url,{responseType:'blob',params});
  session.assertCurrent();
  saveBlob(response.data,filename);
}
